<template>
  <div>
    <LogsFiltros />
    <LogsTabela />
  </div>
</template>
<script>

import LogsFiltros from "@/views/mensagens/logs/LogsFiltros.vue";
import LogsTabela from "@/views/mensagens/logs/LogsTabela.vue";


export default {
  components: {
    LogsFiltros,
    LogsTabela,
  },
  
  mounted() {
    
    const filtros = {
      data_inicio: this.$getDate.hoje(),
      data_final: this.$getDate.hoje(),
      status: '',
      email: '',
      id_company: ''
    }
    
    this.$store.commit('mensagensLogs/SET_FILTROS', filtros)
    this.$store.dispatch('mensagensLogs/listaLogs')
  }
}

</script>
